import { Locales } from 'shared/assets/localization';
import { ID } from 'shared/types/id';

import { createPushToken } from './create-push-token';
import { getPushToken } from './get-push-token';
import { updateUser } from './update-user';

export const setNotificationsOnUser = async (userId: ID, locale: Locales) => {
  if ('Notification' in window && Notification.permission !== 'granted') {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      throw new Error('Notification permission not granted');
    }
  }

  const token = await getPushToken(userId);

  if (!token) {
    throw new Error('Failed to retrieve push token');
  }

  // update user settings
  await updateUser({
    notifications: {
      taskReminder: { desktop: true },
      taskSummary: { desktop: true },
      weeklyReview: { desktop: true },
    },
  });

  await createPushToken(userId, token, locale);
};
